import axios from "axios";
import { BASE_URL } from "./endpoints";

const TOKEN_STORAGE_KEY = "ats_access_token";
const USER_STORAGE_KEY = "ats_login_user";

export const tokenStorage = {
  get: () => localStorage.getItem(TOKEN_STORAGE_KEY),
  set: (token) => localStorage.setItem(TOKEN_STORAGE_KEY, token),
  clear: () => localStorage.removeItem(TOKEN_STORAGE_KEY),
};

// Company-level info (hrms_enabled, plan, etc.) comes back on the /auth/login
// response's `user` object, not from the ATS /me endpoint -- persisted here
// so it survives a page refresh, when AuthContext only has the token to go on.
export const userStorage = {
  get: () => {
    try {
      return JSON.parse(localStorage.getItem(USER_STORAGE_KEY));
    } catch {
      return null;
    }
  },
  set: (user) => localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user)),
  clear: () => localStorage.removeItem(USER_STORAGE_KEY),
};

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// attach the JWT to every outgoing request
apiClient.interceptors.request.use((config) => {
  const token = tokenStorage.get();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// centralize 401 handling -- expired/invalid token bounces to login once,
// rather than every page having to catch this individually
let onUnauthorized = () => {};
export const registerUnauthorizedHandler = (handler) => {
  onUnauthorized = handler;
};

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      tokenStorage.clear();
      userStorage.clear();
      onUnauthorized();
    }
    return Promise.reject(error);
  }
);

export default apiClient;
